import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import type {DownloadButtonAction} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {DownloadFileType, DownloadImageQuality, ImageQualityOption} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import type {AiChatImageDownloadRequest} from '@Components/ai-chat-window/lib/ai-chat-downloads.library.types';
import {AiChatSizedDownloadSource} from '@Libraries/ga-events';
import {assertNever} from '@Utils/assert-never.util';

export const toDownloadRequest = (action: DownloadButtonAction): AiChatImageDownloadRequest => ({
  chatId: action.chatId,
  hashedId: action.hashedId,
  fileType: toFileTypeOption(action.fileType),
  quality: toQualityOption(action.imageQuality),
  targetSize: action.targetSize ?? null,
  source: AiChatSizedDownloadSource.BUTTON,
});

const toQualityOption = (quality: DownloadImageQuality): ImageQualityOption => {
  switch (quality) {
    case DownloadImageQuality.ENHANCED_4K:
      return ImageQualityOption.ENHANCED_4K;
    case DownloadImageQuality.ORIGINAL:
      return ImageQualityOption.ORIGINAL;
    default:
      return assertNever(quality);
  }
};

export const toFileTypeOption = (fileType: DownloadFileType): FileTypeOptions => {
  switch (fileType) {
    case DownloadFileType.JPG:
      return FileTypeOptions.JPG;
    case DownloadFileType.PDF:
      return FileTypeOptions.PDF;
    case DownloadFileType.PNG:
      return FileTypeOptions.PNG;
    default:
      return assertNever(fileType);
  }
};
